import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class GetUserSummaryService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  getUserSummary(userId: string) {
    let sectionId = this.common.getSelectedSection().sectionId;

    // this.storeAuth.getSection().subscribe((value) => {
    //   if (!value) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = value;
    //   }
    // });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/users/summary/${userId}`, { headers: this.headers });
  }

}
